import { render, staticRenderFns } from "./VoiceSearchBarInterface.vue?vue&type=template&id=59f18e6a&scoped=true&"
import script from "./VoiceSearchBarInterface.vue?vue&type=script&lang=js&"
export * from "./VoiceSearchBarInterface.vue?vue&type=script&lang=js&"
import style0 from "./VoiceSearchBarInterface.vue?vue&type=style&index=0&id=59f18e6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f18e6a",
  null
  
)

export default component.exports